import { Container } from "../components/Container/Container";
import { useTranslation } from "react-i18next";
import { FadeInOnScroll } from "../components/FadeInOnScoll/FadeInOnScroll";

export const Music = () => {
  const { t } = useTranslation();

  return (
    <Container className="p-22 -mt-10">
      <FadeInOnScroll>
        <h4 id="music" className="title-page">
          {t("music")}
        </h4>
      </FadeInOnScroll>
      <FadeInOnScroll delay={200}>

        <iframe
          width="100%"
          height="450"
          scrolling="no"
          frameBorder="no"
          allow="autoplay;
          encrypted-media"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/soundcloud%253Aplaylists%253A2250749498&color=%23000000&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true">
        </iframe>
       
      </FadeInOnScroll>
    </Container>
  );
};
